export default "__VITE_ASSET__D6rAw3Bs__"